// Authoritative room-type → room-number map and per-type linen checklist.
// Source: user-provided mapping for "Room types for linen items".
export const ROOM_TYPE_BY_NUMBER = {
  "101": "Deluxe", "103": "Deluxe", "105": "Deluxe", "201": "Deluxe", "203": "Deluxe", "205": "Deluxe", "301": "Deluxe", "303": "Deluxe", "305": "Deluxe",
  "102": "Twin Deluxe", "202": "Twin Deluxe", "302": "Twin Deluxe",
  "104": "Semi Deluxe", "204": "Semi Deluxe", "304": "Semi Deluxe",
  "401": "Cottage", "402": "Cottage", "404": "Cottage",
  "403": "Cottage Twin",
  "405": "Family Suite", "406": "Family Suite",
  "501": "Dormitory",
};

const COMMON = [
  "Pillow", "Pillow Cover", "Small Pillow", "Small Pillow Cover",
  "Hand Towel", "Bath Towel", "Bath Mat", "Runner", "Blanket", "Extra Bed",
];
const DOUBLE = ["Double Duvet Cover", "Double Bedsheet", ...COMMON];
const TWIN = ["Single Duvet Cover", "Single Bedsheet", ...COMMON];

const TWIN_TYPES = new Set(["Twin Deluxe", "Cottage Twin"]);

// Dormitory uses the same linen list as Deluxe (double-bed set), per user.
export const ROOM_TYPES = ["Deluxe", "Twin Deluxe", "Semi Deluxe", "Cottage", "Cottage Twin", "Family Suite", "Dormitory"];

export function linenForType(type) {
  if (!type) return [];
  return TWIN_TYPES.has(type) ? TWIN : DOUBLE;
}

export function roomTypeFor(number) {
  return ROOM_TYPE_BY_NUMBER[String(number)] || null; // null => Setup Pending
}

// Normalize a linen name for matching against Master Linen Stock (ignore case,
// spacing, and a trailing "Std"/"Standard" suffix so we never create duplicates).
export function normLinen(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/\bstd\b|\bstandard\b/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

// Match a checklist linen label to an existing master item by EXACT normalized
// name — or by a normalized alias on the item (e.g. "Bath Mat" → "Mat"). Never fuzzy,
// so we never mis-map e.g. "Pillow" onto "Pillow Cover". Unmatched → Admin mapping.
export function matchItem(label, items) {
  const n = normLinen(label);
  const aliasHit = (i) => {
    const a = i.aliases;
    if (!a) return false;
    const list = Array.isArray(a) ? a : String(a).split(",");
    return list.some(x => normLinen(x) === n);
  };
  return items.find(i => normLinen(i.name) === n) || items.find(aliasHit) || null;
}
